import * as React from 'react';
import { observer } from 'mobx-react';
import RuleRow from 'owa-rules-option-common/lib/components/RuleRow';
import { enableDisableRetentionPolicy, removeRetentionPolicy } from '../actions/internalActions';

export interface PolicyRowProps {
    retentionId: string;
    policyTitle: string;
    policyDescription: string;
    isUserAtActivePolicies: boolean;
    isPolicyRemovable?: boolean;
    isPolicyChecked?: boolean;
}

/**
 * Component to render each policy row
 * @param props
 */
const PolicyRow: React.SFC<PolicyRowProps> = props => {
    const {
        retentionId,
        policyTitle,
        policyDescription,
        isUserAtActivePolicies,
        isPolicyRemovable,
        isPolicyChecked,
    } = props;

    const showDelete = isUserAtActivePolicies && isPolicyRemovable;

    const removePolicy = () => {
        removeRetentionPolicy(retentionId);
    };

    const enableDisablePolicy = (isChecked: boolean) => {
        enableDisableRetentionPolicy(retentionId, isChecked);
    };

    return (
        <RuleRow
            key={retentionId}
            isRetentionRule={true}
            ruleName={policyTitle}
            ruleDescription={policyDescription}
            hideDelete={!showDelete}
            showCheckbox={!isUserAtActivePolicies}
            isChecked={isPolicyChecked}
            enableDisableRule={enableDisablePolicy}
            removeRule={removePolicy}
            isDisabled={false}
        />
    );
};

PolicyRow.defaultProps = { isPolicyRemovable: false, isPolicyChecked: false };

export default observer(PolicyRow);
